import { BaseController } from '../../base/controller';

import template from './userImport.html';

class UserImportController extends BaseController {
  constructor(controllerService, userImportService, $document, notificationService ) {
    'ngInject';
    super({controllerService, userImportService, $document, notificationService });
  }

  close() {
    this.userImportService.closeModal();
  }

  uploadFile() {
    let f = this.$document[0].getElementById('fileUpload').files[0];
    
    if(!f) {
      return this.notificationService.error(this.$translate.instant('userImport.modal.upload.error.fileNotFound'));
    }
    this.isLoading = true;
    this.userImportService.uploadTemplate(f).then(result => {
      this.userImportService.closeModal();
    }).catch(response => {
      const data = response.data || {};
      if (data.error === 'import.error.invalidHeader') {
        this.notificationService.error('userImport.modal.upload.error.invalidHeader', {
          sheet: data.sheet,
          cell: data.cell,
          expectedHeader: data.expectedHeader,
          actualHeader: data.actualHeader,
        });
      } else if (data.error === 'import.error.invalidRow') {
        this.notificationService.error('userImport.modal.upload.error.invalidRow', {
          cause: data.cause,
        });
      } else if (data.error === 'app.error.usernameAlreadyUsed') {
        this.notificationService.error('userImport.modal.upload.error.duplicateUsername', {
          username: data.errorDetails,
        });
      } else {
        this.notificationService.error('userImport.modal.upload.error.unknown');
      }
    }).finally(() => {
      this.isLoading = false;
    });
  }
}

export default {
  restrict: 'E',
  bindings: {},
  template,
  controllerAs: 'vm',
  controller: UserImportController
};
